import axios from 'axios'
import { Message } from 'element-ui'
import { clearAuthLocal } from '@/utils/auth'
import {
  isStorageQuotaPayload,
  showStorageQuotaDialog,
  STORAGE_QUOTA_CODE
} from '@/utils/storage-quota'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  timeout: 20000,
  withCredentials: true
})

service.interceptors.response.use(
  (response) => {
    const res = response.data
    const silent = !!(response.config && response.config.silent)
    if (res && typeof res.code !== 'undefined' && res.code !== 0) {
      const msg = res.message || '请求失败'
      const storageQuota = res.code === STORAGE_QUOTA_CODE && isStorageQuotaPayload(res)
      if (!silent) {
        if (storageQuota && response.config && response.config.storageQuota) {
          showStorageQuotaDialog(res)
        } else {
          Message.error(msg)
        }
      }
      if (res.code === 401) {
        handleUnauthorized()
      }
      const err = new Error(msg)
      if (storageQuota) {
        err.storageQuotaExceeded = true
        err.storageQuotaPayload = res.data || res
      }
      return Promise.reject(err)
    }
    return res
  },
  (error) => {
    const status = error.response && error.response.status
    const data = error.response && error.response.data
    const msg = (data && data.message) || error.message || '网络错误'
    const silent = !!(error.config && error.config.silent)
    const storageQuota = (status === STORAGE_QUOTA_CODE || (data && Number(data.code) === STORAGE_QUOTA_CODE))
      && isStorageQuotaPayload(data || {})

    if (status === 401) {
      handleUnauthorized()
    } else if (status === 403 && data && data.data && data.data.banned) {
      if (!silent) {
        Message.error(msg)
      }
      try {
        const router = require('@/router').default
        if (router && router.currentRoute && router.currentRoute.path !== '/account-banned') {
          router.replace({ path: '/account-banned' }).catch(() => {})
        }
      } catch (e) {
        // ignore
      }
    } else if (!silent) {
      if (storageQuota && error.config && error.config.storageQuota) {
        showStorageQuotaDialog(data || { message: msg })
      } else {
        Message.error(msg)
      }
    }
    const err = error
    if (storageQuota) {
      err.storageQuotaExceeded = true
      err.storageQuotaPayload = (data && data.data) || data
    }
    return Promise.reject(err)
  }
)

let redirecting = false

function handleUnauthorized() {
  clearAuthLocal()
  // 延迟引用，避免与 router 循环依赖
  const store = require('@/store').default
  const router = require('@/router').default
  if (store && store.commit) {
    store.commit('clearUser')
  }
  const path = router.currentRoute && router.currentRoute.path
  if (path === '/login' || redirecting) return
  redirecting = true
  const redirect = router.currentRoute.fullPath
  router
    .replace({
      path: '/login',
      query: redirect && redirect !== '/login' ? { redirect } : {}
    })
    .finally(() => {
      redirecting = false
    })
}

export default service
